import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import userInfo from './userInfo/';
import common from './common/';

export default new Vuex.Store({
    modules: {
        userInfo,
        common,
    }
});